module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_cc0000_256x240-d2954f275f2a6027a6ee3046005a2d4c.png";